var logoData = {
    data: function () {
        return {
            // eslint-disable-next-line global-require,import/no-unresolved
            logo: require("../../public/static/logo/logo.png"),
            // eslint-disable-next-line global-require,import/no-unresolved
            logoNav: require("../../public/static/logo/logoNav.png")
        };
    }
};
export default logoData;
